import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux"
// components
// actions
import CoreAction from "core/actions/common/CoreAction";
// enums
import { Link } from "react-router-dom";
import { Dispatch } from "@reduxjs/toolkit";
import { EContentType } from "cms/enums/EContentType";
import { EViewType } from "cms/enums/EViewType";
import { EView } from "cms/enums/EView";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import ILanguageVersionList from "cms/interfaces/ILanguageVersionList";
import IClientLanguage from "core/interfaces/IClientLanguage";
import IClientSiteSettingDetail from "cms/interfaces/IClientSiteSettingDetail";


function mapStateToProps ( state: any ) {
    console.log("MNPG002.mapStateToProps: ", state);

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const siteSettingDetailPayload:IClientSiteSettingDetail    = state.SiteSettingStore.details?.payload;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        siteSettingDetailPayload

    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("Error404.mapDispatchToProps");

    const coreAction = new CoreAction(dispatch);

    return {

        _hideLoader: () => {
            coreAction.hideLoader()
        },
        _showLoader: () => {
            coreAction.showLoader()
        }

    }
}

const connector = connect( mapStateToProps, mapDispatchToProps );

/* types */
type PropsFromRedux = ConnectedProps<typeof connector>

type TError404<T> = {

} & T;


/* component */
function Error404Loader () {

    return (
        <></>
    )

}

function Error404 ( props: TError404<PropsFromRedux> ) {
    console.log("Error404.rendered:", props)

    const line1 = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.siteSettingDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "404PageLine1" }
        ],
        type: "find"
    });

    const line2 = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.siteSettingDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "404PageLine2" }
        ],
        type: "find"
    });

    const backToHome = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.siteSettingDetailPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "backToHome" }
        ],
        type: "find"
    });


    useEffect(
        () => {

            props._hideLoader();
            
            return function clenup() {
                props._showLoader();
            }

        }, []
    )

    return (
        <section className="error-page">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="error-page__inner">
                            <div className="error-page__title-box">
                                <h2 className="error-page__title">404</h2>
                            </div>
                            <h3 className="error-page__tagline">{line1?.value}</h3>
                            <p className="error-page__text">{line2?.value}</p>
                            <Link to="/" className="thm-btn error-page__btn tw-mt-10">{backToHome?.value}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

};

const Component = React.memo(Error404, ( prevProps: TError404<PropsFromRedux>, nextProps: TError404<PropsFromRedux> ) => {
    console.log("Error404.memo", { prevProps, nextProps });

    console.log("Error404.doNotRender");
    return true;
});

export default connector(Component);
